export const REFS = {
  CONTENT_WRAPPER: 'content-wrapper',
  CONTENT_BODY: 'content-body'
}
